// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3ciXU","colMaxWidth":"Table_colMaxWidth__17ICI"};